import { usePostHog as usePostHogOriginal } from 'posthog-js/react';
import { useAppSelector } from '@/shared/hooks/store';
import { selectIsPosthogInitialized } from '@/store/slices/posthog/selectors';

// Drop-in replacement for posthog-js/react's usePostHog that no-ops until init has actually run.
export const usePostHog = () => {
    const initialized = useAppSelector(selectIsPosthogInitialized);
    const posthog = usePostHogOriginal();
    return initialized ? posthog : undefined;
};
